import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { StripeApi } from "../../api/StripeApi";
import type { StripeCancelReaderRequest } from "../../generated/dto/StripeCancelReaderRequest";
import type { StripeConfiguration } from "../../generated/dto/StripeConfiguration";
import type { StripeReader } from "../../generated/dto/StripeReader";
import type { StripeReaderSimulationResult } from "../../generated/dto/StripeReaderSimulationResult";
import type { StripeSimulateReaderRequest } from "../../generated/dto/StripeSimulateReaderRequest";

export class StripeApiClient implements StripeApi {
  constructor(private readonly client = useClient()) {}

  async cancelReaderStaff(request: StripeCancelReaderRequest): Promise<void> {
    await this.client.post(`/stripe/staff/cancelreader`, serializeCbiDto(request, "generated.dto.StripeCancelReaderRequest"));
  }

  async configurationPublic(): Promise<StripeConfiguration> {
    const { data } = await this.client.post<unknown>(`/stripe/public/configuration`);
    return deserializeCbiDto<StripeConfiguration>(data, "generated.dto.StripeConfiguration");
  }

  async readersStaff(): Promise<Array<StripeReader>> {
    const { data } = await this.client.post<unknown>(`/stripe/staff/readers`);
    return deserializeCbiDto<Array<StripeReader>>(data, "generated.dto.StripeReader");
  }

  async simulateReaderStaff(request: StripeSimulateReaderRequest): Promise<StripeReaderSimulationResult> {
    const { data } = await this.client.post<unknown>(`/stripe/staff/simulatereader`, serializeCbiDto(request, "generated.dto.StripeSimulateReaderRequest"));
    return deserializeCbiDto<StripeReaderSimulationResult>(data, "generated.dto.StripeReaderSimulationResult");
  }
}

export const useStripeApi = (): StripeApi => new StripeApiClient();
